import type { DbTagRow } from '../../resolution/types.js';

export function positionInTag(
  line: number,
  column: number,
  tag: Pick<DbTagRow, 'start_line' | 'start_column' | 'end_line' | 'end_column'>,
): boolean {
  if (line < tag.start_line || line > tag.end_line) return false;
  if (line === tag.start_line && column < tag.start_column) return false;
  if (line === tag.end_line && column >= tag.end_column) return false;
  return true;
}

export function findTagsAtPosition(rows: DbTagRow[], filePath: string, line: number, column: number): DbTagRow[] {
  const zeroLine = line - 1;
  return rows.filter((row) => row.file_path === filePath && positionInTag(zeroLine, column, row));
}

const REF_KIND_PRIORITY = ['type', 'call', 'variable', 'import', 'class', 'module'] as const;

export function pickPrimaryTagAtPosition(rows: DbTagRow[], filePath: string, line: number, column: number): DbTagRow | null {
  const atPos = findTagsAtPosition(rows, filePath, line, column);
  if (atPos.length === 0) return null;

  const modulePath = atPos.find((row) => row.kind === 'module' && row.nav_target_path);
  if (modulePath) return modulePath;

  const named = atPos.filter((row) => row.name.length > 0);
  if (named.length === 0) {
    return atPos.find((row) => row.role === 'ref') ?? atPos.find((row) => row.role === 'def') ?? null;
  }

  const refs = named.filter((row) => row.role === 'ref');
  for (const kind of REF_KIND_PRIORITY) {
    const match = refs.find((row) => row.kind === kind);
    if (match) return match;
  }
  if (refs.length > 0) return refs[0]!;

  return named.find((row) => row.role === 'def') ?? named[0]!;
}
